// extracted by mini-css-extract-plugin
module.exports = {"v17is63o":"v17is63o","index-carousel":"index-carousel"};